import TableHead from '@mui/material/TableHead';
import TableSortLabel from '@mui/material/TableSortLabel';
import Box from '@mui/material/Box';
import { visuallyHidden } from '@mui/utils';
import { AnyObject } from 'yup';
import { useState } from 'react';
import TableListRow from './TableListRow';
import TableListCell from './TableListCell';
import { Order } from '../../../model/table';

type Props = {
	headCells: AnyObject[];
	order?: Order;
	orderBy?: string;
	onClick?: (id: string, order: string) => void;
};

export default function TableListHeader({ headCells, order: or, orderBy: ob, onClick }: Props) {
	const [order, setOrder] = useState<Order>(typeof or !== 'undefined' ? or : 'asc');
	const [orderBy, setOrderBy] = useState(ob);

	const handleClick = onClick
		? (id?: string, o?: Order) => {
				if (id && o) {
					setOrderBy(id);
					if (orderBy === id) {
						setOrder(o as Order);
						onClick(id, o);
					} else {
						setOrder('asc');
						onClick(id, 'asc');
					}
				}
		  }
		: undefined;

	return (
		<TableHead>
			<TableListRow>
				{headCells.map(headCell => (
					<TableListCell
						key={headCell?.id}
						align={headCell?.align || 'left'}
						padding={headCell?.disablePadding ? 'none' : 'normal'}
						sortDirection={orderBy === headCell?.id ? order : false}
						classes={{ head: `${headCell?.width || ''}` }}
					>
						{handleClick ? (
							<TableSortLabel
								active={orderBy === headCell?.id}
								direction={orderBy === headCell?.id ? order : 'asc'}
								onClick={() => handleClick(headCell?.id, order === 'asc' ? 'desc' : 'asc')}
							>
								{headCell?.label}
								{orderBy === headCell?.id ? (
									<Box component='span' sx={visuallyHidden}>
										{order === 'desc' ? 'sorted descending' : 'sorted ascending'}
									</Box>
								) : null}
							</TableSortLabel>
						) : (
							headCell?.label
						)}
					</TableListCell>
				))}
			</TableListRow>
		</TableHead>
	);
}
